import { useMemo } from "react";
import { useHasAnyAccrualLedger } from "@api/ledger.api";
import { useEntities } from "@hooks/useEntities";

export function useIsAccrualLedgerEnabled(): boolean {
    const entities = useEntities({
        onlyBusiness: true,
        excludeMockEntities: true,
    });
    const entityIds = useMemo(
        () => entities.map((entity) => entity.id),
        [entities],
    );
    return useHasAnyAccrualLedger(entityIds);
}
